import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription, take, catchError, debounceTime, distinctUntilChanged, filter, map, of, switchMap, tap } from 'rxjs';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { DocumentoComprovacaoService } from 'src/app/modules/services/documento-comprovacao/documento-comprovacao.service';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { ArquivoVisual, FileManagerConfig } from '../../file-manager/file-manager.interface';
import { FormControl } from '@angular/forms';
import { UserService } from 'src/app/modules/services/user/user.service';

@Component({
  selector: 'app-aprovar-analise',
  templateUrl: './aprovar-analise.component.html',
  styleUrls: ['./aprovar-analise.component.scss']
})
export class AprovarAnaliseComponent implements OnInit {
  minhasImagens: ArquivoVisual[] = [];
  meusDocs: ArquivoVisual[] = [];
  filesAdded: any[] = [];

  minhasImagensArt: ArquivoVisual[] = [];
  meusDocsArt: ArquivoVisual[] = [];
  filesAddedArt: any[] = [];

  fileConfig: FileManagerConfig = {
    permitirUpload: true,
    permitirBaixarTodos: false,
    permitirReiniciar: true,
    modoEdicao: true
  };

  idEntidade: any;
  idProjeto: string | undefined;
  fromProjetos: boolean | undefined;
  isDisciplina: boolean = false;
  cnpj: any;
  comentarios = '';
  idParecer!: string;
  filteredOptions: any[] = [];
  filteredOptionsUsers: any[] = [];
  isAguardandoRevisao: boolean = false;
  isFromProjectDetail: boolean | undefined;
  isEncerrarAnalise: boolean | undefined;
  mostrarParecer: boolean = false;
  tituloModal: string = 'Aprovar';
  subsctiptions: Subscription[] = [];
  searchControl = new FormControl('');
  selectedOption: any;
  responsavel:any = {};
  constructor(
    private documentoComprovacaoService: DocumentoComprovacaoService,
    private projetosService: ProjetosService,
    public toastService: ToastService,
    private entitiesService: EntitiesService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private dialogRef: MatDialogRef<AprovarAnaliseComponent>,
    private formatUtilsService: FormatUtilsService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: {
      idEntidade?: string;
      cnpj?: string;
      idAnaliseAfericao?: string;
      idProjeto?: string;
      fromProjetos?: boolean;
      isDisciplina?: boolean;
      statusAtualId?: string;
      transicaoId?: string;
      transicaoNome?: string;
      mostrarParecer?: boolean;
      isAguardandoRevisao?: boolean;
      isFromProjectDetail?: boolean;
      isEncerrarAnalise?: boolean;
      responsavel?:{}
    }
  ) {
      this.responsavel = data?.responsavel;
      this.searchControl.setValue(this.responsavel && this.responsavel.nome ? this.responsavel.nome : '', { emitEvent: false });
      this.selectedOption = this.responsavel;

  }

  ngOnInit(): void {
    this.initializeFlags();
    this.setupTitle();
    this.getTipoParecer();
    this.setupAutocomplete();
  }

  get isSaveDisabled(): boolean {
    if (this.fromProjetos) {
      return !this.comentarios?.trim() || this.filesAdded.length === 0 || this.filesAddedArt.length === 0;
    }
    if (this.isFromProjectDetail && this.isEncerrarAnalise) {
      return !this.selectedOption || !this.comentarios?.trim() || !this.idParecer || this.isInvalidSubmission();
    }
    if (this.isFromProjectDetail) {
      return !this.selectedOption;
    }
    
    return !this.idParecer && !this.isAguardandoRevisao;
  }

  get cnpjSemFormatacao(): string {
    const cnpjFormatado = this.formatUtilsService.formatCnpj(this.cnpj);
    return cnpjFormatado ? cnpjFormatado.replace(/\D/g, '') : '';
  }

  private initializeFlags(): void {
    this.fromProjetos = this.data?.fromProjetos;
    this.isDisciplina = this.data?.isDisciplina ?? false;
    this.isFromProjectDetail = this.data?.isFromProjectDetail;
    this.idEntidade = this.data?.idEntidade;
    this.idProjeto = this.data?.idProjeto;
    this.cnpj = this.data?.cnpj;
    this.isAguardandoRevisao = this.data?.isAguardandoRevisao ?? false;
    this.mostrarParecer = this.data?.mostrarParecer ?? false;
    this.isEncerrarAnalise = this.data?.isEncerrarAnalise ?? false;
  }

  private setupTitle(): void {
    if (this.data?.transicaoNome) {
      this.tituloModal = this.data.transicaoNome;
    } else if (this.fromProjetos) {
      this.tituloModal = 'Enviar para análise';
    } else if (this.isFromProjectDetail && this.isEncerrarAnalise) {
      this.tituloModal = 'Encerrar análise';
    } else if (this.isFromProjectDetail) {
      this.tituloModal = 'Encaminhar análise';
    } else {
      this.tituloModal = 'Aprovar';
    }
  }

private setupAutocomplete(): void {
    if (this.isFromProjectDetail) {
      this.getFirstUsers();
      this.subsctiptions.push(
        this.searchControl.valueChanges.pipe(
          tap((value) => {
            this.selectedOption = null;
            if (!value || (typeof value === 'string' && value.trim() === '')) {
              this.getFirstUsers();
            }
          }),
          debounceTime(300),
          distinctUntilChanged(),
          filter(value => typeof value === 'string' && value.trim().length > 0),
          map(value => this.normalizeString(value as string)),
          switchMap(value => this.fetchUsers(value))
        ).subscribe((results: any) => {
          this.filteredOptionsUsers = results.content || [];
        })
      );
    }
  }

  private normalizeString(value: string): string {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  }

  private fetchUsers(term: string) {
    return this.userService.getUsers(0, 10, 'asc', 'nome', term, 'true').pipe(
      catchError(() => of([]))
    );
  }
  getFirstUsers(){
    return this.userService.getUsers(0, 10, 'asc', 'nome', '', 'true').subscribe((results:any)=>{
       this.filteredOptionsUsers = results.content || [];
    }

    );
  }

  handleFilesSelected(files: File[], isArt: boolean = false): void {
    files.forEach(file => this.processFile(file, isArt));
  }

  private processFile(file: File, isArt: boolean): void {
    const isImg = file.type.startsWith('image');
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const novoArquivo: ArquivoVisual = {
        nome: file.name,
        url: e.target.result,
        isImagem: isImg,
        rawFile: file
      };

      const objetoParaLista = this.createFileObject(file);
      this.addFileToLists(isArt, isImg, novoArquivo, objetoParaLista);
    };

    reader.readAsDataURL(file);
  }

  private createFileObject(file: File): any {
    return {
      nomeArquivo: file.name,
      tipoMime: file.type.includes('plain') ? file.type : file.type.split('/')[1],
      categoria: 'cadastro_contrato',
      subCategoria: this.cnpjSemFormatacao,
      objetoOriginal: file
    };
  }

  private addFileToLists(isArt: boolean, isImg: boolean, novoArquivo: ArquivoVisual, objetoParaLista: any): void {
    if (isArt) {
      this.filesAddedArt.push(objetoParaLista);
      if (isImg) {
        this.minhasImagensArt = [...this.minhasImagensArt, novoArquivo];
      } else {
        this.meusDocsArt = [...this.meusDocsArt, novoArquivo];
      }
    } else {
      this.filesAdded.push(objetoParaLista);
      if (isImg) {
        this.minhasImagens = [...this.minhasImagens, novoArquivo];
      } else {
        this.meusDocs = [...this.meusDocs, novoArquivo];
      }
    }
  }

  handleItemAction(item: ArquivoVisual, isArt: boolean = false): void {
    if (this.fileConfig.modoEdicao) {
      this.removeItemFromLists(item, isArt);
    } else {
      if (item.url) window.open(item.url as string, '_blank');
    }
  }

  private removeItemFromLists(item: ArquivoVisual, isArt: boolean): void {
    if (isArt) {
      this.minhasImagensArt = this.minhasImagensArt.filter(i => i.nome !== item.nome);
      this.meusDocsArt = this.meusDocsArt.filter(i => i.nome !== item.nome);
      this.filesAddedArt = this.filesAddedArt.filter(i => i.nomeArquivo !== item.nome);
    } else {
      this.minhasImagens = this.minhasImagens.filter(i => i.nome !== item.nome);
      this.meusDocs = this.meusDocs.filter(i => i.nome !== item.nome);
      this.filesAdded = this.filesAdded.filter(i => i.nomeArquivo !== item.nome);
    }
  }

  handleRestart(isArt: boolean = false): void {
    if (isArt) {
      this.filesAddedArt = [];
      this.minhasImagensArt = [];
      this.meusDocsArt = [];
    } else {
      this.filesAdded = [];
      this.minhasImagens = [];
      this.meusDocs = [];
    }
  }

  onSubmit(): void {
   

    if (this.isFromProjectDetail) {
      this.submitProjectDetail();
    } else {
      this.submitGenericAnalysis();
    }
  }

  private isInvalidSubmission(): boolean {
    const hasFiles = this.filesAdded.length > 0 || this.filesAddedArt.length > 0;
    return !!(this.isEncerrarAnalise && hasFiles && !this.cnpjSemFormatacao);
  }

  private mapearArquivosJson(lista: any[]): any[] {
    return lista.map(f => ({
      nomeArquivo: f.nomeArquivo,
      tipoMime: f.tipoMime,
      categoria: this.isEncerrarAnalise ? 'cadastro_contrato' : f.categoria,
      subCategoria:  f.subCategoria
    }));
  }

  private buildComprovacaoData(): any {
    const data: any = {
      comentario: this.comentarios,
      ...(!this.isAguardandoRevisao && !this.fromProjetos && { idParecer: this.idParecer })
    };

    if (this.fromProjetos) {
      data.arquivosGerais = this.mapearArquivosJson(this.filesAdded);
      data.arquivosART = this.mapearArquivosJson(this.filesAddedArt);
    } else {
      data.arquivos = this.mapearArquivosJson(this.filesAdded);
    }

    if (this.isFromProjectDetail) {
      data.idResponsavel = this.selectedOption?.id;
    }

    return data;
  }

  private submitProjectDetail(): void {
    const payload = {
      idExterno: this.data.idAnaliseAfericao,
      idStatusAtual: this.data.statusAtualId,
      idTransicao: this.data.transicaoId,
      idResponsavel: this.selectedOption?.id || null,
      comentario: this.comentarios || null,
      idTipoParecer: this.idParecer,
      anexos: this.mapearArquivosJson(this.filesAdded),
    };
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

    this.appendFilesToFormData(formData, this.filesAdded, 'anexos');
    this.appendFilesToFormData(formData, this.filesAddedArt, 'arquivosArt');

    this.dialogRef.close(formData);
  }

  private submitGenericAnalysis(): void {
    const payloadKey = this.getPayloadKey();
    const comprovacaoData = this.buildComprovacaoData();

    const payload: any = {
      idExterno: this.data.idAnaliseAfericao,
      idStatusAtual: this.data.statusAtualId,
      idTransicao: this.data.transicaoId,
    };

    if (payloadKey === 'analiseProjetoCriacao' && this.isDisciplina) {
      Object.assign(payload, comprovacaoData);
    } else {
      payload[payloadKey] = comprovacaoData;
    }

    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

    this.appendFilesToFormData(formData, this.filesAdded, 'arquivosComprovacao');

    if (this.fromProjetos) {
      this.appendFilesToFormData(formData, this.filesAddedArt, 'arquivosArt');
    }

    this.dialogRef.close(formData);
  }

  private getPayloadKey(): string {
    if (this.isAguardandoRevisao) return 'confirmacaoRevisao';
    if (this.fromProjetos) return 'analiseProjetoCriacao';
    return 'comprovacaoAnalise';
  }

  private appendFilesToFormData(formData: FormData, files: any[], fieldName: string): void {
    files.forEach(f => {
      if (f.objetoOriginal) {
        formData.append(fieldName, f.objetoOriginal, f.nomeArquivo);
      }
    });
  }

  getTipoParecer(): void {
    const request$ = this.isEncerrarAnalise
      ? this.projetosService.getTiposParecerAnaliseProjeto()
      : this.documentoComprovacaoService.getTiposParecer();

    request$
      .pipe(take(1))
      .subscribe({
        next: (results: any) => { this.filteredOptions = results?.content ?? results ?? []; },
        error: () => { this.toastService.showError('Erro ao buscar tipos de parecer.'); }
      });
  }

  onOptionSelected(event: any): void {
    const selectedOption = event.option.value;
    this.selectedOption = selectedOption;
    this.searchControl.setValue(selectedOption.nome, { emitEvent: false });
    this.filteredOptionsUsers = [];
  }

  cancel(): void {
    this.dialogRef.close();
  }
}